import { combineReducers } from "redux";
import useractivity from "../features/admin/activitytracker/useractivity/Slice";




const activitytracker = combineReducers({
   useractivity: useractivity,
  
  });
  
  export default activitytracker;